import { render, staticRenderFns } from "./Prerequisites.vue?vue&type=template&id=5dd88de3&scoped=true&"
import script from "./Prerequisites.vue?vue&type=script&lang=ts&"
export * from "./Prerequisites.vue?vue&type=script&lang=ts&"
import style0 from "./Prerequisites.vue?vue&type=style&index=0&id=5dd88de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd88de3",
  null
  
)

export default component.exports